module.exports = __webpack_public_path__ + "static/media/overpass-extrabold.6e768ba3.woff2";